import React from 'react';
import { Icons } from 'components';
import { func, string } from 'prop-types';

export default function Controls({ onPrevClick, onNextClick, className }) {
    return (
        <div className={className}>
            <button
                className="image-inspector__control-wrapper image-inspector__control-wrapper--left"
                onClick={onPrevClick}
            >
                <Icons.ChevronLeft className="image-product-swipe--previous image-product-swipe__svg" />
            </button>
            <button
                className="image-inspector__control-wrapper image-inspector__control-wrapper--right"
                onClick={onNextClick}
            >
                <Icons.ChevronRight className="image-product-swipe--next image-product-swipe__svg" />
            </button>
        </div>
    );
}

Controls.propTypes = {
    onPrevClick: func,
    onNextClick: func,
    className: string,
};

Controls.defaultProps = {
    onPrevClick: null,
    onNextClick: null,
    className: null,
};
